module.exports = __webpack_public_path__ + "img/globe_icon.2dfc1100.svg";